export enum ProdutoLog {
  DETCLASS = 'DETCLASS',
  ADDCLASS = 'ADDCLASS'
}
